// extracted by mini-css-extract-plugin
module.exports = {"hidden":"new_hidden__DrPzK","textEmphasis":"new_textEmphasis__fl5GN","wrapper":"new_wrapper__AXe_K","edit":"new_edit__FZZpY"};